/**
 * 获取url参数
 *
 * @export
 * @param {*} name
 * @returns 
 */
export function getUrlParam(name) {
    var u = arguments[1] || window.location.search || '',
        reg = new RegExp('(^|&)' + name + '=([^&#]*)(&|$|#)'),
        r = u.substr(u.indexOf('\?') + 1).match(reg);
    return r != null ? r[2] : '';
}

/**
 * 获取url hash后面的参数值
 * @param {*} name 
 */
export function getUrlHash(name) {
    var u = arguments[1] || window.location.hash || '',
        reg = new RegExp('(^|#)' + name + '=([^&]*)(&|$)'),
        r = u.substr(u.indexOf('\?') + 1).match(reg);
    return r != null ? r[2] : '';
}

/**
 * 获取hash名
 *
 * @export
 */
export function getUrlHashName() {
    var u = window.location.hash.slice(2) || '',
        v = u.substr(0, u.indexOf('\?'));
    return v;
}

/**
 * 获取pathname
 *
 * @export
 * @returns
 */
export function getUrlPathName() {
    return window.location.pathname;
}

export function getChannel({ key, url } = { key: 'ADTAG', url: location.href }) {
    return getUrlParam(key, url);
}

//增加url参数
export function addUrlParam(url, key, val) {
    let hash = '';
    let preUrl = url;
    if (url.indexOf('#') >= 0) {
        hash = url.substring(url.indexOf('#'));
        preUrl = url.substring(0, url.indexOf('#'));
    }
    preUrl += preUrl.indexOf('?') < 0 ? `?${key}=${val}` : `&${key}=${val}`;
    preUrl = preUrl.replace(/\&+/g, '&');
    preUrl = preUrl.replace(/\?\&/g, '?');
    return `${preUrl}${hash}`;
}

/**
 * 获取url参数中的adtag值
 *
 * @export
 * @returns
 */
export function getParamAdtag() {
    let tag = getUrlParam('hottag') || getUrlHash('hottag') ||
        getUrlParam('adtag') || getUrlHash('adtag') ||
        getUrlParam('ADTAG') || getUrlHash('ADTAG');
    return tag;
}